import React, { useState, useEffect, useRef } from "react";
import InView from "react-intersection-observer";
import Slider from 'react-slick';
import { SlideInWithScroll } from "../utils/animations/slideInWithScroll";
import HeaderAnim from "../utils/animations/textRevealAnimation";
import { motion, useTransform, useViewportScroll } from 'framer-motion';

export default function FeatureColumn(props) {
  const ref = useRef();
  const [isMobile, setIsMobile] = useState(false);
  const [isVisible, setIsVisible] = useState(false);
  const [elementTop, setElementTop] = useState(0);
  const [clientHeight, setClientHeight] = useState(0);
  const { scrollY } = useViewportScroll();
  const easing = [0.42, 0, 0.58, 1];

  useEffect(() => {
    if (!ref.current) return;

    const setValues = () => {
      setIsMobile(window.innerWidth <= 767);
      setElementTop(ref.current.offsetTop);
      setClientHeight(window.innerHeight);
    };
    setValues();
    window.addEventListener('resize', setValues);
    document.addEventListener('load', setValues);
    return () => {
      window.removeEventListener('resize', setValues);
      document.removeEventListener('load', setValues);
    };
  }, [ref]);
  const y = useTransform(scrollY, [elementTop - clientHeight * 0.7, elementTop], [50, 0], easing);
  const opacity = useTransform(scrollY, [elementTop - clientHeight * 0.7, elementTop], [0, 1], easing);

  const settings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 1023,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        }
      },
    ]
  };

  const triggers = [0.95, 0.85, 0.75, 0.65, 0.55, 0.50, 0.45];
  const { title, header, items, classes } = props.data;

  let featureList = items.map((item, index) => {
    const jsx = (<motion.div className="feature-item-inner">
      <span className="feature-item-icon">{item.icon}</span>
      <h4 className="h5">{item.header}</h4>
      <p>{item.content}</p>
    </motion.div>);

    return <motion.div key={index} className="col feature-item">
      <SlideInWithScroll elementTop={elementTop} clientHeight={clientHeight} children={jsx} triggerPoints={[triggers[index], triggers[index + 2]]} key={index} />
    </motion.div>;
  });

  return (
    <InView onChange={inView => setIsVisible(inView)}>
      <div ref={ref} className={`page-feature-section section-gap-small ${classes}`} id={props.id ? props.id : ''}>
        <div className="container">
          <div className="row d-flex flex-wrap align-v-center">
            <div className="col feature-block-title">
              {/*{title && <p className="theme-color-title">{isVisible && <HeaderAnim header={title} key="mobile-header" />}</p>}*/}
              {header && <h3 className="h4">{header}</h3>}
            </div>
            <div className="col feature-list-block">
              <div className="row feature-list d-flex flex-wrap">
                {!isMobile && <Slider {...settings}>
                  {items && featureList}
                </Slider>}

                {isMobile && <>{items && items.map((item, index) => {
                  return (<div key={index} className="col feature-item">
                    <div className="feature-item-inner">
                      <span className="feature-item-icon">{item.icon}</span>
                      <h4 className="h5">{item.header}</h4>
                      <p>{item.content}</p>
                    </div>
                  </div>);
                })}</>}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="page-section section-gap">
        <div className="container">
          <p>With our end-to-end business, customer, and product expertise for mobile app development, we can help you deliver the simple and high-performing mobile-first products and services in as few as 4 weeks.</p>
        </div>
      </div>
    </InView>
  );
}
